<script lang="ts" setup>
import ExperienceSection from '@/pages/landing-page/sections/ExperienceSection.vue'
import FeaturedCompanies from '@/pages/landing-page/sections/FeaturedCompaniesSection.vue'
import SearchSection from '@/pages/landing-page/sections/SearchSection.vue'

definePage({
  meta: {
    layout: 'landing-page',
    public: true,
  },
})
</script>

<template>
  <SearchSection />
  <!-- <EventStatus /> -->
  <FeaturedCompanies />
  <ExperienceSection />
</template>
